"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Coverage = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Coverage_Class_1 = require("./RTTI_Coverage_Class");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Coverage_CostToBeneficiary_1 = require("./RTTI_Coverage_CostToBeneficiary");
exports.RTTI_Coverage = t.recursion('ICoverage', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Coverage'),
            beneficiary: RTTI_Reference_1.RTTI_Reference,
            payor: t.array(RTTI_Reference_1.RTTI_Reference)
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            policyHolder: RTTI_Reference_1.RTTI_Reference,
            subscriber: RTTI_Reference_1.RTTI_Reference,
            subscriberId: t.string,
            _subscriberId: RTTI_Element_1.RTTI_Element,
            dependent: t.string,
            _dependent: RTTI_Element_1.RTTI_Element,
            relationship: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            period: RTTI_Period_1.RTTI_Period,
            class: t.array(RTTI_Coverage_Class_1.RTTI_Coverage_Class),
            order: RTTI_positiveInt_1.RTTI_positiveInt,
            _order: RTTI_Element_1.RTTI_Element,
            network: t.string,
            _network: RTTI_Element_1.RTTI_Element,
            costToBeneficiary: t.array(RTTI_Coverage_CostToBeneficiary_1.RTTI_Coverage_CostToBeneficiary),
            subrogation: t.boolean,
            _subrogation: RTTI_Element_1.RTTI_Element,
            contract: t.array(RTTI_Reference_1.RTTI_Reference)
        })
    ]);
});
//# sourceMappingURL=RTTI_Coverage.js.map